var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.jobID)?_c('div',[_c('iframe',{ref:"iframe",attrs:{"src":_vm.url,"width":"100%","frameborder":"0","height":"2000px"},on:{"load":_vm.adjustIframe}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }